module.exports = __webpack_public_path__ + "static/media/Accademia - DK Grey_White.142100cb.jpg";